import React, { useState } from "react";
import LoginForm from "../components/loginForm";

const Login = () => {
  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
